<template>
  <div class="v-card-box__main-wrapper" :class="{ [extraClass]: true }">
    <div class="v-card-box__main-wrapper--left" :class="{ ['only']: onlyLeft }">
      <slot name="left-side"></slot>
    </div>

    <div v-if="!onlyLeft" class="v-card-box__main-wrapper--right">
      <div class="v-card-box__main-wrapper--right__circuits"></div>
      <div class="v-card-box__main-wrapper--right__colored"></div>

      <slot name="right-side"></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VCardBox", {
  props: {
    onlyLeft: VueTypes.bool.def(false),
    extraClass: VueTypes.string.def("")
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-card-box";

.#{$ns} {
  &__main-wrapper {
    display: flex;
    justify-content: space-between;
    border: none;
    background-color: #fafafa;
    width: 70%;
    height: 500px;
    margin-top: 35px;
    box-shadow: 0 4px 2px -2px #d2d2d2;
    padding: 40px;
    max-width: 900px;

    &--left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 35%;
      height: 100%;

      &.only {
        width: 100%;
      }
    }

    &--right {
      position: relative;
      width: 50%;
      height: 100%;

      &__circuits {
        position: absolute;
        background: url("../assets/images/circuits-pink_no_background.svg") 120%
          100% no-repeat;
        width: 100%;
        height: 100%;
        background-size: cover;
        transform: rotateY(180deg);
        z-index: 1;
      }

      &__colored {
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(45deg, #5757f5, #8a32f5 95%);
        opacity: 0.83;
        z-index: 2;
      }
    }
  }
}

@media screen and (max-width: 1500px) {
  .#{$ns} {
    &__main-wrapper {
      &--right {
        h3 {
          font-size: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .#{$ns} {
    &__main-wrapper {
      width: 90%;
      flex: 1 1 auto;

      &--right {
        display: none;
      }

      &--left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
